import { render, staticRenderFns } from "./page-genre.vue?vue&type=template&id=19b51b60&scoped=true"
import script from "./page-genre.vue?vue&type=script&lang=js"
export * from "./page-genre.vue?vue&type=script&lang=js"
import style0 from "./page-genre.vue?vue&type=style&index=0&id=19b51b60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b51b60",
  null
  
)

export default component.exports